<li class="portfolio-nav-dropdown dropdown" [class.open]="isOpen()">
	<button
		type="button"
		class="nav-menu-link portfolio-nav-dropdown-toggle dropdown-toggle"
		[attr.aria-expanded]="isOpen()"
		aria-haspopup="menu"
		[attr.aria-controls]="menuId"
		(click)="toggleMenu()"
	>
		<app-icon [icon]="faServerIcon" />
		<span class="nav-label">Portfolios</span>
	</button>
	@if (isOpen()) {
		<ul
			[id]="menuId"
			class="portfolio-nav-dropdown-menu infodocs-dropdown-menu dropdown-menu"
			role="menu"
			(mouseleave)="closeMenu()"
		>
			<li class="portfolio-nav-item-companies" role="menuitem">
				<a
					class="portfolio-nav-dropdown-item infodocs-dropdown-menu__item"
					[routerLink]="companiesRoute()"
					routerLinkActive="infodocs-dropdown-menu__item--active"
					(click)="closeMenu()"
				>
					<span class="portfolio-nav-dropdown-item-icon portfolio-nav-item-icon-companies">
						<app-icon [icon]="faLandmarkIcon" />
					</span>
					<span class="portfolio-nav-dropdown-item-text">
						<span class="portfolio-nav-dropdown-item-label">Companies</span>
					</span>
				</a>
			</li>
			<li class="portfolio-nav-item-trusts" role="menuitem">
				<a
					class="portfolio-nav-dropdown-item infodocs-dropdown-menu__item"
					[routerLink]="trustsLink"
					routerLinkActive="infodocs-dropdown-menu__item--active"
					(click)="closeMenu()"
				>
					<span class="portfolio-nav-dropdown-item-icon portfolio-nav-item-icon-trusts">
						<app-icon [icon]="faFileContractIcon" />
					</span>
					<span class="portfolio-nav-dropdown-item-text">
						<span class="portfolio-nav-dropdown-item-label">Trusts</span>
					</span>
				</a>
			</li>
			<li class="portfolio-nav-item-individuals" role="menuitem">
				<a
					class="portfolio-nav-dropdown-item infodocs-dropdown-menu__item portfolio-nav-dropdown-item--disabled"
					aria-disabled="true"
					tabindex="-1"
					(click)="$event.preventDefault()"
				>
					<span class="portfolio-nav-dropdown-item-icon portfolio-nav-item-icon-individuals">
						<app-icon [icon]="faUserIcon" />
					</span>
					<span class="portfolio-nav-dropdown-item-text">
						<span class="portfolio-nav-dropdown-item-label">Individuals</span>
						<span
							class="portfolio-nav-coming-soon-hint portfolio-nav-dropdown-item-description"
							role="status"
						>
							Coming soon
						</span>
					</span>
				</a>
			</li>
		</ul>
	}
</li>
